import { Component, OnInit, AfterViewInit, Input, HostListener } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { IomService } from 'src/app/services/iom.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionService } from 'src/app/services/session.service';
import { DataQualityAssessmentComponent } from 'src/app/components/data-quality-assessment/data-quality-assessment.component';
import * as d3 from 'd3';
declare var bootbox: any;
declare var $: any;

@Component({
    selector: 'app-doughnut-clickable-chart',
    templateUrl: './doughnut-clickable-chart.component.html'
})

export class DoughnutChartComponent implements OnInit {
    @Input() GraphData: any;
    VersionId: string;
    flag: boolean;
    constructor(private spinner: NgxSpinnerService, public iomservice: IomService, private sessionService: SessionService, public dataQualityService: DataQualityAssessmentComponent) { }
    ngOnInit(): void {
    }
    ngAfterViewInit() {
        this.RenderDoughnutChartsWithLabel(this.GraphData);
    }
    ngOnChanges() {
        this.RenderDoughnutChartsWithLabel(this.GraphData);
    }
    RenderDoughnutChartsWithLabel(inputData) {
        let that = this;
        const padAngle = 0.015; // effectively dictates the gap between slices
        const cornerRadius = 3; // sets how rounded the corners are on each slice
        d3.select(inputData.chartContainerName).html("");
        d3.select(inputData.chartContainerName).classed('piewithlables', true);
        //console.log('pie width : ' + pieChartContainer.clientWidth)
        var w = d3.select(inputData.chartContainerName).node().offsetWidth;
        var h = 350;
        var padding = 10;
        var opacity = 1;
        var otherOpacityOnHover = .9;
        var tempData1 = 0;
        var tempData2 = 0;
        //var color = d3.scaleOrdinal(d3.schemeCategory10);
        var margin = {
            top: 20,
            bottom: 90,
            left: 0,
            right: 0,
        };
        var colors = ['#46BDF0', '#98BB56', '#6FD9DD', '#5589BB', '#68C083', '#2B7BAD', '#E370B3'];
        //var colors = ['#46BDF0', '#2B7BAD', '#6FD9DD', '#E370B3', '#E4E4E4', '#AA6544', '#5589BB', '#68C083', '#A260B7', '#E370B3'];
        var width = w - margin.left - margin.right;
        var height = h - margin.top - margin.bottom;
        var radius = Math.min(width - padding, height - padding) / 2;
       
        var svg = d3.select(inputData.chartContainerName)
            .append('svg')
            .attr('class', 'pie')
            .attr('id', 'svg_' + inputData.chartContainerName.split('#')[1])
            .classed("resizableSVG", true)
            .attr('xmlns', "http://www.w3.org/2000/svg")
            .attr('viewBox', "0 0 " + w + " " + h + "")
            .attr('preserveAspectRatio', 'xMidYMid meet')
            //.attr('svg_' + chartContainer.split('#')[1])
            .style('overflow', 'visible')
            .append('g')
            .attr('height', height)
            .attr('width', width);
        var outerArc = d3.arc()
            .outerRadius(radius + 7)
            .innerRadius(radius + 7);
        var arc = d3.arc()
            .innerRadius(radius - 40)
            .outerRadius(radius - 5)
            .cornerRadius(cornerRadius)
        //.padAngle(padAngle);

        var arc2 = d3.arc()
            .outerRadius(radius + 5)
            .innerRadius(radius - 40);
        //var arc3 = d3.arc()
        //    .outerRadius(2 * radius)
        //    .innerRadius(0);
        var data = [];
        inputData.xAxisCategories.forEach((d, i) => {
            var x = inputData.newKeys.indexOf(d);
            if (x >= 0)
                data.push(inputData.chartData.filter(y => y.sankeyXData == d)[0])
        });
        var totalCount = d3.sum(data, function (d) { return parseInt(d.sankeyData); });
        // console.log("total count:" + totalCount);
        var pie = d3.pie()
            .value((d) => parseInt(d.sankeyData))
            .sort(null);

        var g1 = svg.append('g')
            .attr('transform', 'translate(' + (width / 2) + ',' + ((height / 2) + margin.top) + ')');
        var g = svg.append('g')
            .attr('transform', 'translate(' + (width / 2) + ',' + ((height / 2) + margin.top) + ')');


        var path1 = g1.selectAll('path')
            .data(pie(data))
            .enter()
            .append("g")
            .append('path')
            .attr('d', arc2)
            .classed('HoverPath', true)
            .classed(inputData.chartContainerName.split('#')[1] + "_PiePath", true)
            .attr('id', (d, i) => 'HoverPath_' + i)
            .attr('fill', (d, i) => {
                //colors[i % colors.length]
                i = inputData.xAxisCategories.indexOf(d.data.sankeyXData);
                if (i >= 0) {
                    return colors[i % colors.length];
                }
            })// getColor(d.data.sankeyXData.toUpperCase())))
            .style('opacity', 0)
            .attr('stroke', 'white')
            .attr('stroke-width', 1)

        var path = g.selectAll('g')
            .data(pie(data))
            .enter()
            .append("g")

        var arcs = path.append('path')
            .attr('d', arc)
            .attr('fill', (d, i) => {
                //colors[i % colors.length]
                i = inputData.xAxisCategories.indexOf(d.data.sankeyXData);
                if (i >= 0) {
                    return colors[i % colors.length];
                }
            })//getColor(d.data.sankeyXData.toUpperCase())))
            .style('opacity', opacity)
            .classed(inputData.chartContainerName.split('#')[1] + "_PiePath", true)
            //.attr('class',(d,i) => inputData.chartContainerName.split('#')[1] + "_PiePath" + i)
            .attr('stroke', 'white')
            .attr('stroke-width', 1)
            .on('click', (d, i) => {
                console.log(d, i)
                that.dataQualityService.LoadWordCloud(d, i)
                //bootbox.alert("test");
            })
            .on("mouseover", function (d, i) {
                //d3.select(inputData.chartContainerName).select('svg')
                d3.selectAll('.' + inputData.chartContainerName.split('#')[1] + "_PiePath")
                    //.selectAll('path')
                    .style("opacity", otherOpacityOnHover)
                    .attr('d', arc);
                d3.select(this)
                    .attr("d", arc2)
                    .style("opacity", 0.3);
                that.mouseHover(inputData.chartContainerName, this, d.data.sankeyXData, d.data.sankeyData, i, d.data.XAxis, totalCount);
            })
            .on("mousemove", function (d) {
                var transformResult = that.mouseMove(inputData.chartContainerName, this, height, width);
                d3.select(inputData.chartContainerName).select("svg").select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${transformResult.x}, ${transformResult.y})`);
            })
            .on("mouseout", function (d, i) {
                that.mouseOut(inputData.chartContainerName, this, opacity, i);
                //d3.select(inputData.chartContainerName).select('svg')
                d3.selectAll('.' + inputData.chartContainerName.split('#')[1] + "_PiePath")
                    //.selectAll('path')
                    .style("opacity", otherOpacityOnHover)
                    .attr("d", arc)
            });
        var previousValuePieY1 = 0, previousValuePieY2 = 0, previousValueLineY1 = 0, previousValueLineY2 = 0;
        g.append('g').classed('labels', true);
        this.flag = false;
        for (let i = 0; i < inputData.newKeys.length; i++) {
            for(let j = 0; j < inputData.chartData.length; j++){
                if(inputData.newKeys[i]==inputData.chartData[j].sankeyXData){
                    if(inputData.chartData[j].sankeyData>0){
                        this.flag = true;
                    }
                }
            }
        }
        if(this.flag == true){
        var labels = g.select('.labels').selectAll('text')
            .data(pie(data))
            .enter().append('text')
            .html(function (d) {
                //return d.data[chartProperties.yAxisParameter];
                //var percentage = Math.round(((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) * 100) / 100 + "%";
                //return percentage;
                return ' (' + Math.floor(parseInt(d.data.sankeyData) / totalCount * 100) + '%)';
            })
            .attr('font-family', 'Graphik SemiBold')
            .style("opacity", function (d) {
                var pos = outerArc.centroid(d);
                var currentValuePieX = pos[0] = (radius) * 1.3 * (that.midAngle(d) < Math.PI ? 1 : -1);
                var currentValuePieY1, currentValuePieY2;
                (currentValuePieX > 0) ? currentValuePieY1 = pos[1] - 1.5 : currentValuePieY2 = pos[1] - 1.5;
                var posdiff = (currentValuePieX > 0) ? currentValuePieY1 - previousValuePieY1 : currentValuePieY2 - previousValuePieY2;
                if (posdiff < 0) { posdiff = -posdiff; }
                else { posdiff = posdiff; }
                if (posdiff < 10) {
                    if ((currentValuePieX < 0 && previousValuePieY2 == 0) || (currentValuePieX > 0 && previousValuePieY1 == 0)) {
                        (currentValuePieX > 0) ? previousValuePieY1 = currentValuePieY1 : previousValuePieY2 = currentValuePieY2;
                        return 0.8;
                    } else {
                        (currentValuePieX > 0) ? previousValuePieY1 = currentValuePieY1 : previousValuePieY2 = currentValuePieY2;
                        return 0.8;
                    }
                } else {
                    (currentValuePieX > 0) ? previousValuePieY1 = currentValuePieY1 : previousValuePieY2 = currentValuePieY2;
                    return 0.8;
                }
            })
            .attr('transform', function (d) {
                var pos = outerArc.centroid(d);
                pos[0] = (radius) * 1.3 * (that.midAngle(d) < Math.PI ? 1 : -1);
                pos[1] = pos[1] - 1.5;
                if(d.data.sankeyData == 0){
                    tempData1 = tempData1 + 1;
                }
                if(tempData1 == 2)
                {
                    pos[1] = pos[1] + 25;
                    //d.data.sankeyData = d.value + 0.5;
                }
                else if(tempData1 == 3)
                {
                    pos[1] = pos[1] + 50;
                    //d.data.sankeyData = d.value + 0.75;
                }
                return 'translate(' + pos + ')';
            })
            .attr("text-anchor", "middle")
            .attr("font-size", "10px")
            .attr("font-weight", "bolder")
            .style("fill", 'black');
        g.append('g').classed('lines', true);
        var polylines = g.select('.lines')
            .selectAll('polyline')
            .data(pie(data))
            .enter()
            .append('polyline')
            .attr('points', function (d) {
                // console.log("data:" + inputData.chartData[0])
                if(d.data.sankeyData == 0){
                    tempData2 = tempData2 + 1;
                }
                var pos = outerArc.centroid(d);
                pos[0] = (radius * 1.3) * (that.midAngle(d) < Math.PI ? 1 : -1);                
                pos[1] = pos[1] + 0.5;
                if(tempData2 == 2)
                {
                    pos[1] = pos[1] + 25;
                }
                else if(tempData2 == 3)
                {
                    pos[1] = pos[1] + 50;
                }
                //console.log("polyline :" + d.value + "|" + pos[0] + "|" + pos[1] +  "|" + pos);
                return [arc.centroid(d), outerArc.centroid(d), pos]
            })
            //.style("stroke", 'black')
            .style('fill', 'none')
            //.style("stroke", function (d, i) { return colors(i); })
            .style("stroke-width", "1px")
            .attr("stroke", "#707070")
            .attr("stroke-dasharray", "1")
            .style("opacity", function (d) {
                var pos = outerArc.centroid(d);
                var currentValueLineX = pos[0] = (radius) * 1.3 * (that.midAngle(d) < Math.PI ? 1 : -1);
                var currentValueLineY1, currentValueLineY2;
                (currentValueLineX > 0) ? currentValueLineY1 = pos[1] - 1.5 : currentValueLineY2 = pos[1] - 1.5;
                var posdiff = (currentValueLineX > 0) ? currentValueLineY1 - previousValueLineY1 : currentValueLineY2 - previousValueLineY2;
                if (posdiff < 0) { posdiff = -posdiff; }
                else { posdiff = posdiff; }
                if (posdiff < 10) {
                    if ((currentValueLineX < 0 && previousValueLineY2 == 0) || (currentValueLineX > 0 && previousValueLineY1 == 0)) {
                        (currentValueLineX > 0) ? previousValueLineY1 = currentValueLineY1 : previousValueLineY2 = currentValueLineY2;
                        return 0.8;
                    } else {
                        (currentValueLineX > 0) ? previousValueLineY1 = currentValueLineY1 : previousValueLineY2 = currentValueLineY2;
                        return 0.8;
                    }
                } else {
                    (currentValueLineX > 0) ? previousValueLineY1 = currentValueLineY1 : previousValueLineY2 = currentValueLineY2;
                    return 0.8;
                }
            })
            .on("mouseover", function (d, i) {
                //d3.select(inputData.chartContainerName).select('svg')
                d3.selectAll('.' + inputData.chartContainerName.split('#')[1] + "_PiePath")
                    //.selectAll('path')
                    .style("opacity", otherOpacityOnHover)
                    .attr('d', arc);
                d3.select(this)
                    .attr("d", arc2)
                    .style("opacity", 0.3);
                that.mouseHover(inputData.chartContainerName, this, d.data.sankeyXData, d.data.sankeyData, i, d.data.XAxis, totalCount);
            })
            .on("mousemove", function (d) {
                var transformResult = that.mouseMove(inputData.chartContainerName, this, height, width);
                d3.select(inputData.chartContainerName).select("svg").select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${transformResult.x}, ${transformResult.y})`);
            })
            .on("mouseout", function (d, i) {
                that.mouseOut(inputData.chartContainerName, this, opacity, i);
                //d3.select(inputData.chartContainerName).select('svg')
                d3.selectAll('.' + inputData.chartContainerName.split('#')[1] + "_PiePath")
                    //.selectAll('path')
                    .style("opacity", otherOpacityOnHover)
                    .attr("d", arc)
            });
        }

        var legendsSVG = svg.append('g')
            .attr('transform', "translate(" + 30 + "," + (height + margin.top + 20) + ")")
            .attr('width', width - 30)
            .attr('height', h - (height + (2 * margin.top) + 20))
            .style('overflow', 'auto');
        legendsSVG.append('rect')
            .attr('fill', 'none')
            .attr('rx', "0")
            .attr('ry', "0")
            .attr('x', "0")
            .attr('y', "0")
            .attr('width', width - margin.left)
            .attr('height', h - (height + (2 * margin.top) + 20))
        var legendGroups = legendsSVG.append('g');
        var legendGroup = legendGroups.append('g').selectAll('g')
            .data(inputData.xAxisCategories)
            .enter()
            .append('g')
            .on('click', (d, i) => {
                //console.log('clicked' + i);
                if ($(legendGroup.nodes()[i]).find('rect').attr('fill') != '#cccccc') {
                    inputData.newKeys.splice(inputData.newKeys.indexOf(d), 1);
                    //$(legendGroup.nodes()[i]).find('rect').attr('fill','#cccccc');
                }
                else {
                    inputData.newKeys.splice(inputData.xAxisCategories.indexOf(d) + 1, 0, d);
                }
                var x = parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id);
                inputData.currentGroup = x;
                that.RenderDoughnutChartsWithLabel(inputData);
            });
        legendGroup.append('text')
            .style("color", "#015b63")
            .style("font-size", "12px")
            .style("font-weight", "bold")
            .style("cursor", "pointer")
            .style("fill", "#015b63")
            .attr("text-anchor", "start")
            .attr("x", "21")
            .attr("y", "15")
            .style('font-family', 'Graphik Regular')
            .append('tspan')
            .text((d, i) => {
                return (d.length > 30 ? d.substring(0, 30) + "..." : d);
            })
            .append('title')
            .text(d => d)
            .on('mouseover', (d, i) => {
                $(legendGroup.selectAll('text').nodes()[i]).css('fill', 'black');
            })
            .on('mouseout', (d, i) => {
                $(legendGroup.selectAll('text').nodes()[i]).css('fill', "#015b63");
            });
        legendGroup.append('rect')
            .attr("x", "2")
            .attr("y", "4")
            .attr("width", "12")
            .attr("height", "12")
            .attr('fill', (d, i) => {
                return colors[i % colors.length];
            })
            .attr("rx", "6")
            .attr("ry", "6");
        var symbol = d3.symbol();
        var legendScroll = legendGroups.append('g')
            .attr('transform', "translate(" + (width - 30) + "," + 5 + ")")
            .attr('class', 'legendscroll');
        var LegentScrollText = legendScroll.append('text')
        legendScroll.append("path")
            .attr("d", symbol.type(d3.symbolTriangle))
            .attr('class', 'uppertriangle')
            .attr('fill', '#cccccc')
            .style('cursor', 'default')
            .on('click', () => {
                var i = parseInt(legendGroup.nodes().filter(d => $(d).css('display') != 'none')[0].id);
                var totalGrps = parseInt(legendScroll.attr('total'));
                if (i == 1)
                    return;
                if (i > 1) {
                    legendGroup.nodes().filter(d => d.getAttribute('id') == i)
                        .forEach((d, i) => d.setAttribute('display', 'none'));
                    var lblGrps = legendGroup.nodes().filter(d => d.getAttribute('id') == (i - 1));
                    that.scrollLegends(lblGrps, width - 40, legendScroll, false, LegentScrollText);
                    legendScroll.select('text')
                        .text((i - 1) + "/" + totalGrps);
                }
                if (i != 1 && (i - 1) < totalGrps) {
                    legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
                    $(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
                }
                else {
                    legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
                    $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
                }
                if ((i - 1) <= 1) {
                    //legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
                    //$(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
                    legendScroll.select('.uppertriangle').node().setAttribute('fill', '#cccccc');
                    $(legendScroll.select('.uppertriangle').node()).css('cursor', 'default');
                }
                else {
                    legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
                    $(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
                }
            });
        //var dummyLegendGroup = legendGroup;
        legendScroll.append("path")
            .attr("d", symbol.type(d3.symbolTriangle))
            .attr('transform', "translate(0" + "," + 30 + ") rotate(180)")
            .attr('class', 'lowertriangle')
            .style('cursor', 'pointer')
            .attr('fill', '#003399')
            .on('click', () => {
                that.clickScrollDown(legendGroup.nodes(), width, legendScroll, false, LegentScrollText, 1);
            });
        var grpNodes = legendGroup.nodes();
        that.scrollLegends(grpNodes, width - 40, legendScroll, true, LegentScrollText);
        if (inputData.currentGroup != 1) {
            //grpNodes = grpNodes.filter(d => d.getAttribute('id') == inputData.currentGroup);
            //scrollLegends(grpNodes, width, legendScroll, true, LegentScrollText);
            that.clickScrollDown(grpNodes, width - 40, legendScroll, false, LegentScrollText, (inputData.currentGroup - 1));
        }
        else {
            grpNodes.filter(d => d.getAttribute('id') != 1)
                .forEach((d, i) => d.setAttribute('display', 'none'));
        }
        inputData.xAxisCategories.forEach((d, i) => {
            if (!inputData.newKeys.includes(d))
                $(legendGroup.nodes()[i]).find('rect').attr('fill', '#cccccc');
        });
    }
    clickScrollDown(legendGroupNodes, width, legendScroll, isUpdateId, LegentScrollText, increment) {
        var i = parseInt(legendGroupNodes.filter(d => $(d).css('display') != 'none')[0].id);
        width = width - 40;
        var totalGrps = parseInt(legendScroll.attr('total'));
        if (totalGrps > i) {
            legendGroupNodes.filter(d => d.getAttribute('id') != (i + increment))
                .forEach((d, i) => d.setAttribute('display', 'none'));
            legendGroupNodes.filter(d => d.getAttribute('id') == (i + increment))
                .forEach((d, i) => d.setAttribute('display', 'block'));
            var lblGrps = legendGroupNodes.filter(d => d.getAttribute('id') == (i + increment));
            this.scrollLegends(lblGrps, width, legendScroll, isUpdateId, LegentScrollText);
            legendScroll.select('text')
                .text((i + increment) + "/" + totalGrps);
            legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
            $(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
        }
        if ((i + increment) >= totalGrps) {
            //legendScroll.select('.uppertriangle').node().setAttribute('fill', '#003399');
            //$(legendScroll.select('.uppertriangle').node()).css('cursor', 'pointer');
            legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
            $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
        }
        else {
            legendScroll.select('.lowertriangle').node().setAttribute('fill', '#003399');
            $(legendScroll.select('.lowertriangle').node()).css('cursor', 'pointer');
        }
    }
    scrollLegends(legendGroupNodes, width, legendScroll, isUpdateId, LegentScrollText) {
        var labels = legendGroupNodes//.nodes()//.selectAll('text');
        var textWidth = 0;
        var textHeight = 0;
        var space = 15;
        var totalLines = 1;
        var groupNumber = 1;
        var startPosition = 0;
        var totalWidth = 0;
        labels.forEach(function (d, i) { totalWidth += (d.getBBox().width + space) });
        labels.forEach(function (d, i) {
            //var x = labels.map(function (d, i) { return (d.getBBox().width + space) });
            //var totalWidth = x[x.length - 1];      
            if (totalLines == 1 && totalWidth <= width && textWidth == 0) {
                startPosition = (width / 2) - (totalWidth / 2);
            }
            if ((textWidth + d.getBBox().width) <= width) {
                if (startPosition == 0) {
                    labels[i].setAttribute('transform', 'translate(' + textWidth + ',' + textHeight + ')');
                }
                else {
                    labels[i].setAttribute('transform', 'translate(' + startPosition + ',' + 0 + ')');
                    textWidth = startPosition;
                    startPosition = 0;
                }
                labels[i].setAttribute('display', 'block')
                if (isUpdateId)
                    labels[i].setAttribute('id', groupNumber);
            }
            else {
                totalLines += 1;
                textWidth = 0;
                textHeight += 22;
                labels[i].setAttribute('transform', 'translate(' + textWidth + ',' + textHeight + ')');
                labels[i].setAttribute('display', 'block')
                if (totalLines > 2 && totalLines % 2 != 0)
                    groupNumber += 1;
                if (isUpdateId)
                    labels[i].setAttribute('id', groupNumber);
            }
            textWidth += d.getBBox().width;
            textWidth += space;
        });
        let totalPageText = "1/" + Math.ceil(totalLines / 2);
        let x = totalPageText.length * 2;
        LegentScrollText
            .text(totalPageText)
            .attr('fill', 'rgb(1, 91, 99)')
            .attr('transform', "translate(-" + x + "," + 20 + ")")
            .style('font-size', '10px');
        if (isUpdateId)
            legendScroll.attr('total', Math.ceil(totalLines / 2));
        if (Math.ceil(totalLines / 2) == 1) {
            legendScroll.select('.lowertriangle').node().setAttribute('fill', '#cccccc');
            $(legendScroll.select('.lowertriangle').node()).css('cursor', 'default');
        }
    }
    mouseHover(container, pathElement, name, value, i, xaxis, totalCount) {
        d3.select(pathElement).style('cursor', 'pointer');
        d3.select(container).select("svg").select('#trend_circle_' + i).style("display", 'block');
        var tooltip = d3.select(container).select("svg")
            .append("g")
            .style("cursor", "pointer")
            .attr("class", "tooltip")
            .style("opacity", 1)
        tooltip.append("rect")
            .attr("width", 90)
            .attr('height', 50)
            .style('fill', '#FFFFFF')
            .style('pointer-events', 'none')
            .style('stroke', this.ConvertRGB2Hex(d3.select(pathElement).style('fill')) == '#ffffff' ? "#296986" : d3.select(pathElement).style('fill'))
            .style('stroke-width', 2)
            .style('fill-opacity', 0.8);
        var textSvg = tooltip.append("text")
            .attr('x', 7)
            .attr('y', 15)
            .style('pointer-events', 'none')
            .style('fill', '#333333')
            .style('font-size', '12px')
            .style('color', '#333333');
        textSvg.append("tspan")
            .style('font-size', '10px')
            .style('pointer-events', 'none')
            .style('font-weight', 'bold')
            .text(name)
            textSvg.append("tspan")
            .attr('x', 7)
            .attr('dy', 15)
            .style('pointer-events', 'none')
            .style('fill', this.ConvertRGB2Hex(d3.select(pathElement).style('fill')) == '#ffffff' ? "#296986" : d3.select(pathElement).style('fill'))
            .html('&#x25cf') //&#9679; //&bull;
        textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-size', '11px')
            .text("Count: ")
            .style('font-weight', 'bold')
        textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-weight', 'bold')
            .text('(' + value + ')');
        textSvg.append("tspan")
            .attr('x', 7)
            .attr('dy', 15)
            .style('pointer-events', 'none')
            .style('fill', this.ConvertRGB2Hex(d3.select(pathElement).style('fill')) == '#ffffff' ? "#296986" : d3.select(pathElement).style('fill'))
            .html('&#x25cf') //&#9679; //&bull;
        textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-size', '11px')
            .text("Percentage: ")
            .style('font-weight', 'bold')
        textSvg.append("tspan")
            .attr('dx', 0)
            .style('pointer-events', 'none')
            .style('font-weight', 'bold')
            .text(' (' + Math.floor(parseInt(value) / totalCount * 100) + '%)');
    }
    mouseMove(container, pathElement, height, width) {
        d3.select(pathElement).style('cursor', 'pointer');
        var mousePosition = d3.mouse(pathElement);
        var x = mousePosition[0] + width / 2;
        //console.log("0 : " + mousePosition[0] + "x : " + x);
        var y = mousePosition[1] + height / 2;
        //console.log("1 : " + mousePosition[1] + "y : " + y);
        var text = d3.select(container).select("svg").select('.tooltip text');
        var bbox = text.node().getBBox();
        //console.log("bbox w : " + bbox.width);
        d3.select(container).select("svg").select('.tooltip rect')
            .attr("width", bbox.width + 15)
        //console.log("bbox h : " + bbox.height);
        if (x - bbox.width / 2 < 0) {
            x = bbox.width / 2;
        }
        else if (width - x - bbox.width / 2 < 0) {
            x = width - bbox.width / 2;
        }
        if (y - bbox.height / 2 < 0) {
            y = bbox.height * 2;
        }
        else if (height - y - bbox.height / 2 < 0) {
            y = height - bbox.height / 2;
        }
        return {
            'x': x, 'y': y
        };
        // when mouse moves         
        //console.log("mouse X: " + d3.event.layerX);
        //console.log("mouse Y: " + d3.event.layerY);
        //console.log(d3.select(pieChartContainer.nativeElement).select("svg").select('.tooltip').html());
        //d3.select(pieChartContainer.nativeElement).select("svg").select('.tooltip')//.style('top', (d3.event.layerY + 10) + 'px') // always 10px below the cursor
        //    .attr('transform', `translate(${d3.event.layerX-30}, ${d3.event.layerY-30})`)
        //.style('left', (d3.event.layerX + 10) + 'px'); // always 10px to the right of the mouse    
    }
    mouseOut(container, pathElement, opacity, i) {
        d3.select(container).select("svg").select('.tooltip').style('display', 'none');
        d3.select(container).select("svg").select('#trend_circle_' + i).style("display", 'none');
        d3.select(container).select("svg")
            .select(".tooltip").remove();
        d3.select(pathElement).selectAll('path')
            .style("opacity", opacity);
    }
    ConvertRGB2Hex(rgb) {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
    }
    midAngle(d) {
        return d.startAngle + (d.endAngle - d.startAngle) / 2;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.RenderDoughnutChartsWithLabel(this.GraphData);
    }
}